import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  loadMoreProviders: {
    id: 'button.load_more_providers',
    description: 'Button text for the load more providers button on map-search',
    defaultMessage: 'Load More Providers'
  }
});
